import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService, ResponseObject } from './auth.service';
import { ServiceBase } from './service.base';
import { Injectable } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { SetupItems } from '../models/setupItems';

@Injectable({
  providedIn: 'root'
})
export class ArtTypeService extends ServiceBase {

  constructor(private http: HttpClient,
    authService: AuthService) {
    super(authService);
  }

  public fetch(filterRoleBasedArttypes: boolean = true): Observable<SetupItems[]> {
    const httpOptions = this.RequestHeaders();
    const api: string = '/ArtType';
    const method: string = '/fetch/' + filterRoleBasedArttypes;
    const url: string = environment.BASE_API_PATH + api + method;
    return this.http.get<SetupItems[]>(url, httpOptions);
  }

  public getPrimaryArtType(): Observable<SelectItem> {
    const httpOptions = this.RequestHeaders();
    const api: string = '/ArtType';
    const method: string = '/primary-arttype';
    const url: string = environment.BASE_API_PATH + api + method;
    return this.http.get<SelectItem>(url, httpOptions);
  }
  public fetchArttype(filterRoleBasedArttypes: boolean = false): Observable<SetupItems[]> {
    const httpOptions = this.RequestHeaders();
    const api: string = '/ArtType';
    const method: string = '/fetch/' + filterRoleBasedArttypes;
    const url: string = environment.BASE_API_PATH + api + method;
    return this.http.get<SetupItems[]>(url, httpOptions);
  }

  public save(artist: SetupItems): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const api: string = '/ArtType';
    const method: string = '/save';
    const url: string = environment.BASE_API_PATH + api + method;
    return this.http.post<ResponseObject>(url, artist, httpOptions);
  }

  public delete(artistId: string): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const api: string = '/ArtType';
    const method: string = '/deleteArtType/';
    const url: string = environment.BASE_API_PATH + api + method + artistId;
    return this.http.delete<ResponseObject>(url, httpOptions);
  }
}
